import { useState } from "react"
import { Input, Label, Button, Form, InputGroup } from "reactstrap"
import { toast } from "react-toastify"

import supabase from "../../utils/subabaseClient"


export default function AddMembers({
  members,
  setMembers,
}) {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)

  const addNewMember = async (email) => {
    if (!email) return

    setLoading(true)
    const { data, error } = await supabase
      .from("symfonia_users")
      .select()
      .eq("email", email)

    if (error) {
      console.log(error)
      toast.error(error.message)
    } else {
      if (data.length === 0) {
        toast.error("User not found")
      } else {
        setMembers([
          ...members,
          {
            email: data[0].email,
            auth_user_id: data[0].auth_user_id,
          },
        ])
        setEmail("")
      }
    }
    setLoading(false)
  }

  return (
    <div className="mt-2">
      <Label>Add Members</Label>
      <Form
        action="#"
        onSubmit={(e) => {
          e.preventDefault()
          addNewMember(email)
        }}
      >
        <InputGroup className="mt-2">
          <Input
            type="email"
            placeholder="Enter member email"
            value={email}
            required
            onChange={(event) => {
              setEmail(event.target.value)
            }}
          />

          <Button color="primary" type="submit" disabled={loading}>
            <i className="bx bx-plus"></i>
          </Button>
        </InputGroup>
      </Form>
      <div className="">
        {members.map((member, idx) => (
          <InputGroup key={idx} className="mt-2">
            <Input type="email" value={member.email} required disabled />

            <Button
              color="danger "
              onClick={() =>
                setMembers(
                  members.filter((m) => m.auth_user_id !== member.auth_user_id)
                )
              }
            >
              <i className="bx bx-trash"></i>
            </Button>
          </InputGroup>
        ))}
      </div>
    </div>
  )
}
